module.exports = __webpack_public_path__ + "static/media/gov_business.5c703f8c.png";